<template>
    <q-card flat square :dark="dark" class="q-pa-none">

        <q-card-section class="row">
            <div class="col-12 q-pa-sm">
                <q-input :dark="dark" dense outlined v-model="email" type="email" label="email address"/>
            </div>

            <div class="col-12 q-pa-sm">
                <q-input :dark="dark" dense outlined v-model="password" type="password" label="password">
                    <template v-slot:append>
                    <q-icon name="help" class="cursor-pointer" size="xs"  @click="forgot = true">
                        <q-tooltip>Forgot Password</q-tooltip>
                    </q-icon>
                    </template>
                </q-input>
            </div>

        </q-card-section>

        <q-dialog v-model="forgot" persistent>
            <q-card :dark="dark" style="width: 400px; max-width: 95vw">

                <q-bar :dark="dark" class="bg-primary" :style="{ color: textColor }" >
                    <q-icon name="help" />
                    <div> Forgot Password </div>
                    <q-space />
                    <q-btn round flat icon="cancel" padding="none" size="sm" @click="forgot = false" />
                </q-bar>

                <q-card-section>
                    <div class="text">Provide your registered email address.  If the email address is found in our system we will send a password reset link.</div>
                </q-card-section>

                <q-card-section class="q-pt-none">
                    <q-input :dark="dark" outlined dense v-model="forgotEmail" label="Registration Token" />
                </q-card-section>

                <q-card-actions class="q-px-md">
                    <q-btn class="full-width" :dark="dark" unelevated color="primary" label="Send Password Reset Link" @click="sendForgot"  />
                </q-card-actions>
            </q-card>
        </q-dialog>
    </q-card>
</template>

<script>
import { colors } from 'quasar'
const { brightness, getBrand } = colors
import validator from 'validator'

export default {
    data() {
        return {
            email: null,
            password: null,
            forgotEmail: null,
            forgot: false
        }
    },

    created() {
        this.$store.state.ids.loginId = null
        this.$store.state.ids.password = null
    },

    computed: {
        pageStyle() {
            if (this.theme.dark_mode) return {
                backgroundColor: this.settings.theme.dark_background
            }
            else return {
                backgroundColor: this.settings.theme.background
            }
        },

        textColor() {
            const a1 = getBrand('primary')
            if (brightness(a1) > 128) return "#333"
            else return '#fafafa'
        },

        dark() {
            if (this.$store.state.config.dark_mode) return true
            else return false
        }
    },

    methods: {
        sendForgot() {
            if (!this.forgotEmail) return
            if (!validator.isEmail(this.forgotEmail)) return this.showError('Email address is not valid')

        },

        showError(e) {
            this.$q.notify({
                message: e,
                color: 'negative',
                icon: 'error',
                position: 'center',
                progress: true,
                actions: [{ label: 'OK', color: 'white', handler: () => { } }]
            })
        },

    },
}
</script>

<style></style>